var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessLarge = function SvgSuccessLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.322 63.2 6.562 6.562-2.262 2.263-6.562-6.562 2.262-2.263Zm2.714-45.563-2.132 7.935-5.8-5.808 7.932-2.127Zm-73.552-6.13 7.936 2.129-5.808 5.808-2.128-7.936Z",
    fill: "#28BF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 8.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM14 29a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm57 56a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm-57.992-3.556 5.808-5.824-7.936-2.112 2.128 7.936Z",
    fill: "#FFD527"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.001 20.5a28 28 0 1 1 0 56 28 28 0 0 1 0-56Zm43 28.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0ZM43.872 91.939l2.263 2.26 6.566-6.56-2.263-2.262-6.566 6.562ZM2.117 60.362l2.263 2.263 6.562-6.562L8.68 53.8l-6.562 6.562ZM43.101 5.774l6.562 6.562 2.258-2.263-6.562-6.561-2.258 2.262Z",
    fill: "#116DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.467 60.436 34.195 50.164l3.392-3.408 6.88 6.896 15.968-15.984 3.392 3.408-19.36 19.36Z",
    fill: "#fff"
  })));
};
export default SvgSuccessLarge;